import React from 'react';
import { companyInfo } from '../data/mock';

const LogoBanner = () => {
  return (
    <section 
      className="logo-banner-section"
      style={{
        position: 'relative',
        padding: '120px 0',
        background: '#000000',
        overflow: 'hidden'
      }}
    >
      {/* Animated 3D Background */}
      <div className="background-3d">
        <div className="floating-circle circle-1"></div>
        <div className="floating-circle circle-2"></div>
        <div className="floating-circle circle-3"></div>
      </div>

      {/* Content */}
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div style={{ textAlign: 'center' }}>
          {/* Large Logo */}
          <img
            src={companyInfo.logo}
            alt={companyInfo.name}
            style={{
              maxWidth: '600px',
              width: '90%',
              height: 'auto',
              margin: '0 auto 40px',
              filter: 'drop-shadow(0 10px 30px rgba(184, 134, 11, 0.3))',
              animation: 'logoFloat 6s ease-in-out infinite'
            }}
          />
          
          {/* Tagline */}
          <p 
            className="hero-medium"
            style={{
              color: '#DAA520',
              marginBottom: '24px',
              maxWidth: '800px',
              margin: '0 auto 24px',
              fontSize: 'clamp(18px, 3vw, 26px)',
              lineHeight: '1.5'
            }}
          >
            {companyInfo.tagline}
          </p>

          {/* Divider */}
          <div style={{
            width: '120px',
            height: '2px',
            background: 'linear-gradient(90deg, transparent, #DAA520, transparent)',
            margin: '40px auto'
          }} />

          {/* Description */}
          <p 
            className="body-large"
            style={{
              color: '#F5F5DC',
              maxWidth: '700px',
              margin: '0 auto',
              lineHeight: '1.8',
              opacity: 0.9
            }}
          >
            Specialist dalam pernikahan adat Sunda, Jawa, Bali, dan konsep modern minimalist
          </p>
        </div>
      </div>

      <style jsx="true">{`
        @keyframes logoFloat {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        .background-3d {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          z-index: 1;
        }

        .floating-circle {
          position: absolute;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(218, 165, 32, 0.1), transparent);
          filter: blur(60px);
          animation: float 20s ease-in-out infinite;
        }

        .circle-1 {
          width: 500px;
          height: 500px;
          top: -200px;
          left: -100px;
          animation-delay: 0s;
        }

        .circle-2 {
          width: 400px;
          height: 400px;
          bottom: -150px;
          right: -50px;
          animation-delay: 7s;
        }

        .circle-3 {
          width: 350px;
          height: 350px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          animation-delay: 14s;
        }

        @keyframes float {
          0%, 100% {
            transform: translate(0, 0) scale(1);
            opacity: 0.3;
          }
          33% {
            transform: translate(50px, -50px) scale(1.1);
            opacity: 0.5;
          }
          66% {
            transform: translate(-50px, 50px) scale(0.9);
            opacity: 0.4;
          }
        }

        @media (max-width: 640px) {
          .floating-circle {
            width: 250px !important;
            height: 250px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default LogoBanner;
